"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var victory_1 = require("victory");
var formatters_1 = require("utils/formatters");
var barGraphStyles_1 = require("./styles/barGraphStyles");
// Domain
// {width: 450, height: 158 x: [-0.725, 1]},
// {width: 300, height: 80 x: [-0.725, 0.8375]},
// main secondary neutral
var BenchmarkBar = function (_a) {
    var _b = _a.min, min = _b === void 0 ? 9 : _b, _c = _a.median, median = _c === void 0 ? 56 : _c, _d = _a.max, max = _d === void 0 ? 90 : _d, _e = _a.mark, mark = _e === void 0 ? 65 : _e, _f = _a.size, size = _f === void 0 ? 'sm' : _f, type = _a.type, propsHeight = _a.height, propsWidth = _a.width;
    var _g = barGraphStyles_1.SIZE_MAPPER[size], cornerRadius = _g.cornerRadius, barWidth = _g.barWidth, sidePaddings = _g.sidePaddings, fontSize = _g.fontSize, dotStrokeWidth = _g.dotStrokeWidth, dotSize = _g.dotSize, strokeWidth = _g.strokeWidth, defaultHeight = _g.height, defaultWidth = _g.width;
    var height = propsHeight !== null && propsHeight !== void 0 ? propsHeight : defaultHeight;
    var width = propsWidth !== null && propsWidth !== void 0 ? propsWidth : defaultWidth;
    var getColor = (0, barGraphStyles_1.makeGetColor)(type);
    return ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ width: width, height: height }, { children: (0, jsx_runtime_1.jsxs)(victory_1.VictoryGroup, __assign({ style: { parent: { maxWidth: '100%' } }, domain: { x: [-0.725, 0.8375], y: type === 'percent' ? [0, 1] : [Math.min(min, mark), Math.max(max, mark)] }, padding: { top: 0, bottom: 0, left: sidePaddings, right: sidePaddings }, offset: -barWidth * 0.5, height: height, width: width }, { children: [(0, jsx_runtime_1.jsx)(victory_1.VictoryBar, { horizontal: true, data: [
                        { id: 'bar', x: 0, y0: min, y: max },
                        { id: 'medianBar', x: 0, y0: median, y: median },
                        { id: 'markOverlay', x: 0, y0: min, y: mark },
                        { id: 'mark', x: 0, y0: mark, y: mark },
                        { id: 'min', x: 0, y0: min, y: min },
                    ], cornerRadius: {
                        bottom: function (_a) {
                            var id = _a.datum.id;
                            return id === 'bar' ? cornerRadius : 0;
                        },
                        top: function (_a) {
                            var id = _a.datum.id;
                            return id === 'bar' ? cornerRadius : 0;
                        },
                    }, style: {
                        data: {
                            width: barWidth,
                            fill: (0, barGraphStyles_1.getStyle)('fill', undefined, getColor),
                            strokeWidth: function (arg) { return (0, barGraphStyles_1.getStyle)('hasStrokeWidth')(arg) ? strokeWidth : 0; },
                        },
                        labels: { fill: (0, barGraphStyles_1.getStyle)('label.fill', undefined, getColor), fontSize: fontSize, fontFamily: 'Fellix', fontWeight: 700 },
                    }, labels: [
                        type === 'percent' ? (0, formatters_1.formatPercent)(max) : (0, formatters_1.formatMoney)(Math.round(max), 'AUD', 'NEW'),
                        '',
                        '',
                        type === 'percent' ? (0, formatters_1.formatPercent)(mark) : (0, formatters_1.formatMoney)(Math.round(mark), 'AUD', 'NEW'),
                        type === 'percent' ? (0, formatters_1.formatPercent)(min) : (0, formatters_1.formatMoney)(Math.round(min), 'AUD', 'NEW'),
                    ], labelComponent: ((0, jsx_runtime_1.jsx)(victory_1.VictoryLabel, { backgroundStyle: { fill: (0, barGraphStyles_1.getStyle)('label.background.fill', undefined, getColor) }, textAnchor: (0, barGraphStyles_1.getLabelsStyle)('textAnchor', 'start'), dx: (0, barGraphStyles_1.getLabelsStyle)('dx', 8) })) }), (0, jsx_runtime_1.jsx)(victory_1.VictoryScatter, { style: { data: { fill: '#FF9FBF', stroke: '#FFF', strokeWidth: dotStrokeWidth } }, size: dotSize, data: [{ x: 0, y: mark }], labels: ['YOU'], labelComponent: ((0, jsx_runtime_1.jsx)(victory_1.VictoryLabel, { textAnchor: "middle", dy: 14, dx: 0, style: [{ fill: '#9CA9B0', fontSize: fontSize * 0.75, fontFamily: 'Fellix', fontWeight: 600 }] })) })] })) })));
};
exports.default = react_1.default.memo(BenchmarkBar);
